<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-customer" class="modal absolute block w-5/6 sm:w-9/12 md:w-5/12 bg-white shadow-md rounded-lg"
      :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">PIN</h5>
      </div>
      <div id="modal-body" class="p-5">
        <InputText v-model="pin" id="pin" label="PIN" placeholder="Masukkan PIN" input_class="w-full" type="password" />
        <InputText v-if="isVoid" v-model="note" id="note" label="Alasan" placeholder="Masukkan alasan" input_class="w-full" />
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submitPin" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputText from '@/components/form/InputText.vue';
import SubmitButton from '@/components/form/SubmitButton.vue';

export default {
  name: "ModalPin",
  props: {
    isVoid: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    SubmitButton, InputText
  },
  data() {
    return {
      showModal: true,
      pin: '',
      note: '',
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitPin() {
      try {
        this.$emit('submitpin', { pin: this.pin, note: this.note });

        this.closeModal();
      }
      catch (error) {
        console.error('Failed to save item:', error);
      }
    }
  }
}
</script>